module.exports = __webpack_public_path__ + "img/Colorization1.5a2edc53.webp";